const RAC_LINK = 'https://docs.netmaker.io/pro/rac.html';
const WIREGUARD_LINK = 'https://docs.netmaker.io/integrating-non-native-devices.html';
const EGRESS_IMG = '/egress.webp';
const RAG_IMG = '/rag.webp';
const NET_IMG = '/network.webp';

export const Links = {
  RAC_LINK,
  WIREGUARD_LINK,
};

export const Images = {
  EGRESS_IMG,
  RAG_IMG,
  NET_IMG,
};
